import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import * as _ from "lodash";
import { KreFormAntService } from "../tools/service";
import { NzModalService } from "ng-zorro-antd/modal";
import { KreDialogService } from "../service/dialog.service";

import { KreFormTree } from "../components/tree/index.component";
import { KreFormEmployee } from "../components/employee/index.component";
import { KreFormOrg } from "../components/org/index.component";
import { KreFormPostion } from "../components/postion/index.component";
import { KreFormArea } from "../components/area/index.component";

@Component({
  selector: "krefield-lookup",
  template: `
    <ng-container *ngIf="formStatus !== 0">
      <div class="fieldOperational">
        <div class="fieldcheckbox">
          <label
            *ngIf="isCheckboxShow == true"
            nz-checkbox
            [(ngModel)]="field.checked"
          ></label>
        </div>
        <div class="fieldControl">
          <div class="label">
            <span *ngIf="to.required">*</span>{{ to.label }}
          </div>
          <div class="control">
            <input nz-input disabled />
          </div>
          <kreform-fieldbutton
            *ngIf="isCheckboxShow == true"
            [field]="field"
            (buttonClick)="fieldOperational($event)"
          ></kreform-fieldbutton>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formStatus === 0">
      <ng-container *ngIf="editor === true">
        <nz-input-group [nzSuffix]="suffixTemplate">
          <input
            nz-input
            [class.is-invalid]="showError"
            [placeholder]="placeHolder"
            [value]="textLookUp"
            readonly="true"
          />
        </nz-input-group>
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->

        <nz-input-group [nzSuffix]="suffixTemplate" style="display:none;">
          <input
            nz-input
            [formControl]="formControl"
            [kreFormAttributes]="field"
            [class.is-invalid]="showError"
            readonly="true"
        /></nz-input-group>
      </ng-container>

      <div class="fieldtext" *ngIf="editor === false">{{ textLookUp }}</div>
    </ng-container>
    <ng-template #suffixTemplate>
      <i (click)="lookup()" class="icon-tianjin"></i>
      <!--<i
        nz-icon
        nzType="close"
        nzTheme="outline"
        (click)="removeValue()"
        *ngIf="textLookUp != null && textLookUp != ''"
      ></i>-->
    </ng-template>
  `,
})
export class KreFormFieldLookUp extends FieldType {
  service: any;

  constructor(
    dyService: KreFormAntService,
    private modal: NzModalService,
    public kreDialogService: KreDialogService
  ) {
    super();
    this.service = dyService;
  }

  fieldOperational(sign: string) {
    this.service.fieldOperational(sign, this.field);
  }

  lookup() {
    let template: any;
    let type = _.get(this.field, "templateOptions.type");
    let para = {
      fieldConfig: this.field,
      tag: false,
    };
    switch (type) {
      case "tree":
        template = KreFormTree;
        para.tag = true;
        break;
        break;
      case "employee":
        template = KreFormEmployee;
        break;
      case "organizational":
        template = KreFormOrg;
        para.tag = true;
        break;
      case "position":
        template = KreFormPostion;
        break;
      case "area":
        template = KreFormArea;
        break;
      default:
        break;
    }
    if (template) {
      this.kreDialogService.CreateModelDialog(
        {
          nzTitle: "选择 - " + this.to["label"],
          size: "large",
          nzContent: template,
        },
        para,
        (instance: any, modal: any) => {
          let res: any = instance.selectedNode;
          if (
            this.model != undefined &&
            this.model != null &&
            this.key != undefined &&
            this.key != null
          ) {
            if (res != null && res.length > 0) {
              this.model[this.key] = res;

              this.formControl.markAsTouched();
            } else {
              this.model[this.key] = [];

              this.formControl.markAsTouched();
            }
          } else {
            this.model[this.key] = res;

            this.formControl.markAsTouched();
          }
          modal.destroy();
        }
      );
    }
  }

  removeValue() {
    if (
      this.model != undefined &&
      this.model != null &&
      this.key != undefined &&
      this.key != null &&
      this.model[this.key] != undefined &&
      this.model[this.key] != null
    ) {
      this.model[this.key] = [];

      this.formControl.markAsTouched();
    }
  }
}
